export const getImage = (uri) => uri ? `https://ellco.ru/storage/${uri}` : 'https://avatars.mds.yandex.net/get-autoru-vos/1894023/61931bfe5d45bd46d36e9a8ee8523170/1200x900n';
